import { createContext, useEffect } from "react";
import useAvailablePatient from "../components/patients/hooks/usePatient";
import { useAuth } from "./AuthContext";
import useGeneralNotification from "../components/patients/hooks/useNotifcation";

// Context removed as it was unused. This component operates as a side-effect manager.

export const NotificationProvider = () => {
  const { user } = useAuth();

  const date = new Date();
  const todayDate = `${date.getFullYear()}-${String(
    date.getMonth() + 1
  ).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;

  // Fetch available patients
  const { availabilities: availablePatients = [] } = useAvailablePatient({
    clinicId: user?.id || "",
    date: new Date(todayDate).toISOString(),
  });

  const { notifications } = useGeneralNotification({
    toId: String(user?.id),
    notify: true,
  });
  console.log("USer Notifications", notifications);

  useEffect(() => {
    if (availablePatients.length === 0) return; // Ensure patients are available

    const hasActiveCall = availablePatients.some(
      (patient) => patient.callStatus === "Active"
    );

    // 🛑 Prevent Redirection Loop
    if (hasActiveCall && window.location.pathname !== "/clinic/appointments") {
      console.log("Navigating to /clinic/appointments..."); // Debug log
      window.history.pushState({}, "", "/clinic/appointments"); // ✅ Change URL without reloading
    }
  }, [availablePatients]);

  return null; // No UI needed
};
